// extracted by mini-css-extract-plugin
export default {"video":"video_video__5Usgc","videoFull":"video_videoFull__Gqdhl"};